/** Web: HTMLAudio in play* utilities; this stub satisfies static imports. */
export default class Sound {
  static MAIN_BUNDLE = '';
  static DOCUMENT = '';
  static LIBRARY = '';
  static CACHES = '';
  static setCategory(_c: string, _mix?: boolean): void {}
  static setMode(_m: string): void {}
  static setActive(_v: boolean): void {}
  // Файл — путь или результат `require()` ассета (на нативе это число).
  constructor(
    _filename: string | number,
    _basePathOrCb?: string | ((e: Error | null) => void),
    _cb?: (e: Error | null) => void,
  ) {}
  setNumberOfLoops(_n: number): void {}
  setVolume(_v: number): void {}
  play(_onEnd?: (success: boolean) => void): void {}
  pause(_cb?: () => void): void {}
  stop(_cb?: () => void): void {}
  release(): void {}
}
